import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  baseFastApiMedicalTreatmentRoute,
  baseFastApiMatterRoute,
} from "@/lib/data/requests/matters/matter";
import { serializeMedicalTreatmentBalanceConfirmationPayload } from "@/lib/data/requests/matters/medical-treatment-payloads";
import {
  type APIResponse,
  type MedicalTreatmentBalanceConfirmation,
  type SourceOwnedConnectionCreate,
} from "@/lib/types";

export const createMedicalTreatmentBalanceConfirmationV3 = (
  data: Pick<MedicalTreatmentBalanceConfirmation, "matterId"> &
    Partial<Omit<MedicalTreatmentBalanceConfirmation, "connections">> & {
      connections?: SourceOwnedConnectionCreate[];
    },
) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MedicalTreatmentBalanceConfirmation>>(
      "matters/v4/medical-treatments/balance-confirmations",
      {
        ...serializeMedicalTreatmentBalanceConfirmationPayload(data),
        connections: data.connections ?? [],
      },
    )
    .then((res) => res.data);
};

export const updateMedicalTreatmentBalanceConfirmationV1 = (
  data: Pick<
    MedicalTreatmentBalanceConfirmation,
    "id" | "dateModified" | "matterId"
  > &
    Partial<MedicalTreatmentBalanceConfirmation>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MedicalTreatmentBalanceConfirmation>
    >(`${baseFastApiMedicalTreatmentRoute}/balance-confirmations`, serializeMedicalTreatmentBalanceConfirmationPayload(data))
    .then((res) => res.data);
};

export const deleteMedicalTreatmentBalanceConfirmationV1 = (
  data: Pick<MedicalTreatmentBalanceConfirmation, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MedicalTreatmentBalanceConfirmation>
    >(`${baseFastApiMatterRoute}/medical-treatments/balance-confirmations/${id}`)
    .then((res) => res.data);
};
